import { print } from "graphql";
import { Client } from "graphql-ws";
import { getCurrentDeviceQueryKey } from "./use-get-current-device";
import {
	SubscribeToCurrentDeviceDocument,
	SubscribeToCurrentDeviceSubscription,
} from "~/types/__generated/gql/graphql";
import { queryClient } from "~/providers/query-provider";

void (
	/* GraphQL */ `
		subscription SubscribeToCurrentDevice {
			subscribeToCurrentDevice {
				type
				id
			}
		}
	`
);

export const subscribeToCurrentDevice = (client: Client) =>
	client.subscribe<SubscribeToCurrentDeviceSubscription>(
		{ query: print(SubscribeToCurrentDeviceDocument) },
		{
			next: async () => {
				const queryKey = getCurrentDeviceQueryKey();
				await queryClient.invalidateQueries({ queryKey, exact: true });
			},
			error: (error) => console.error(error),
			complete: () => undefined,
		},
	);
